module.exports = __webpack_public_path__ + "static/media/herotext.91b46f5c.svg";